import type { IReuseGridProps } from 'types';
import { Grid, Typography } from '@mui/material';

const ReuseGrid = (props: IReuseGridProps): JSX.Element => {
  return (
    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', padding: 1 }}>
      <Grid item xs={4} sm={4} md={4}>
        <Typography
          component="h5"
          variant="h5"
          color="#838383"
          fontWeight={700}
          fontSize={16}
          fontFamily="Inter !important"
        >
          {props.customName}
        </Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography>:</Typography>
      </Grid>
      &nbsp;
      <Grid item xs={4} sm={4} md={4}>
        <Typography
          component="h5"
          variant="h5"
          color={'#000000'}
          fontWeight={700}
          fontSize={16}
          fontFamily="Inter !important"
        >
          {props.customerDetails}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ReuseGrid;
